import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-food-order-list',
  templateUrl: './food-order-list.component.html',
  styleUrls: ['./food-order-list.component.scss']
})
export class FoodOrderListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
